// GAELON i18n dictionaries — PT-BR, EN, ES, ZH (Simplified)
const translations = {
  "pt-br": {
    locale: "pt-br",
    htmlLang: "pt-BR",
    nav: {
      capabilities: "Capacidades",
      technology: "Tecnologia",
      showcase: "Resultados",
      philosophy: "Filosofia",
      contact: "Contato",
      bookCall: "Agendar Consultoria",
    },
    hero: {
      eyebrow: "Infraestrutura de Inteligência",
      headlineLine1: "INFRAESTRUTURA",
      headlineLine2: "DE INTELIGÊNCIA",
      headlineLine3: "PARA A PRÓXIMA ERA",
      sub: "Construímos sistemas autônomos de IA que redefinem automação, tomada de decisão e o potencial humano.",
      ctaPrimary: "Agendar Consultoria",
      ctaSecondary: "Explorar Sistemas",
      scrollHint: "Role para descobrir",
    },
    mission: {
      eyebrow: "Missão",
      line1: "A tecnologia deve",
      line2: "desaparecer dentro",
      line3: "da inteligência.",
      sub: "Tudo o que construímos move organizações além da automação rumo à execução autônoma.",
    },
    capabilities: {
      eyebrow: "Capacidades",
      title: "Sistemas concebidos como infraestrutura.",
      sub: "Seis disciplinas. Uma arquitetura unificada de inteligência.",
      items: [
        { slug: "infra", title: "AI Infrastructure", desc: "Plataformas de inteligência de ponta a ponta — escaláveis, observáveis, soberanas." },
        { slug: "autonomous", title: "Autonomous Systems", desc: "Sistemas autônomos de execução contínua, capazes de operar sem supervisão humana." },
        { slug: "agents", title: "AI Agents", desc: "Agentes especialistas que colaboram, raciocinam e executam em escala empresarial." },
        { slug: "automation", title: "Enterprise Automation", desc: "Reengenharia de fluxos críticos em camadas autônomas de decisão e ação." },
        { slug: "architecture", title: "Intelligence Architecture", desc: "Projetamos a arquitetura de inteligência que governa toda a organização." },
        { slug: "predictive", title: "Predictive Intelligence", desc: "Modelos preditivos que antecipam mercados, riscos e oportunidades em tempo real." },
      ],
    },
    technology: {
      eyebrow: "Tecnologia",
      title: "Uma arquitetura. Cinco camadas.",
      sub: "Cada sistema GAELON é construído sobre uma pilha proprietária integrada verticalmente.",
      nodes: [
        { slug: "neural", title: "Neural Systems", desc: "Modelos fundacionais e redes neurais especializadas." },
        { slug: "agents", title: "Autonomous Agents", desc: "Agentes operacionais com raciocínio em múltiplas etapas." },
        { slug: "engines", title: "Decision Engines", desc: "Motores de decisão determinísticos e auditáveis." },
        { slug: "execution", title: "Enterprise Execution", desc: "Integração nativa com a infraestrutura corporativa." },
        { slug: "learning", title: "Continuous Learning", desc: "Aprendizado contínuo e otimização em produção." },
      ],
    },
    showcase: {
      eyebrow: "Resultados",
      title: "Operando em escala industrial.",
      stats: [
        { slug: "cost", value: "82%", label: "Redução de custos operacionais" },
        { slug: "workflows", value: "40,000+", label: "Fluxos automatizados em produção" },
        { slug: "efficiency", value: "340%", label: "Crescimento de eficiência operacional" },
      ],
      caption: "Indicadores agregados de implementações empresariais.",
    },
    philosophy: {
      eyebrow: "Filosofia",
      paragraphs: [
        "Acreditamos que a inteligência é a próxima camada de infraestrutura da civilização.",
        "Organizações não operarão mais por execução manual.",
        "Elas operarão por inteligência autônoma.",
        "Estamos construindo esse futuro.",
      ],
      signature: "— GAELON",
    },
    global: {
      eyebrow: "Presença Global",
      title: "Construindo sistemas de inteligência para organizações no mundo todo.",
      regions: [
        { slug: "brazil", name: "Brasil" },
        { slug: "usa", name: "Estados Unidos" },
        { slug: "europe", name: "Europa" },
        { slug: "middle-east", name: "Oriente Médio" },
        { slug: "asia", name: "Ásia" },
      ],
    },
    finalCta: {
      line1: "CONSTRUA O FUTURO",
      line2: "ANTES QUE ELE CHEGUE.",
      sub: "Uma conversa estratégica com a GAELON. Sem custos. Sem fricções.",
      cta: "Começar com a GAELON",
    },
    contact: {
      eyebrow: "Contato",
      title: "Vamos arquitetar sua próxima era.",
      sub: "Conte-nos sobre sua organização. Responderemos em até 24 horas.",
      name: "Nome",
      email: "E-mail corporativo",
      company: "Empresa",
      message: "Como podemos ajudar?",
      submit: "Falar no WhatsApp",
      submitting: "Abrindo…",
      success: "Redirecionando para o WhatsApp da GAELON.",
      error: "Não foi possível enviar. Tente novamente em instantes.",
    },
    newsletter: {
      title: "Inteligência. Direto na sua caixa de entrada.",
      placeholder: "Seu e-mail corporativo",
      submit: "Inscrever",
      submitting: "Enviando…",
      success: "Inscrição confirmada.",
      error: "Falha ao inscrever. Tente novamente.",
    },
    footer: {
      tagline: "Infraestrutura de inteligência para a próxima era.",
      nav: "Navegação",
      contact: "Contato",
      social: "Social",
      language: "Idioma",
      company: "Empresa",
      sac: "SAC",
      rights: "Todos os direitos reservados.",
    },
  },

  en: {
    locale: "en",
    htmlLang: "en",
    nav: {
      capabilities: "Capabilities",
      technology: "Technology",
      showcase: "Showcase",
      philosophy: "Philosophy",
      contact: "Contact",
      bookCall: "Book a Strategy Call",
    },
    hero: {
      eyebrow: "Intelligence Infrastructure",
      headlineLine1: "INTELLIGENCE",
      headlineLine2: "INFRASTRUCTURE",
      headlineLine3: "FOR THE NEXT ERA",
      sub: "We build autonomous AI systems that redefine automation, decision-making and human potential.",
      ctaPrimary: "Book a Strategy Call",
      ctaSecondary: "Explore Systems",
      scrollHint: "Scroll to enter",
    },
    mission: {
      eyebrow: "Mission",
      line1: "Technology should",
      line2: "disappear into",
      line3: "intelligence.",
      sub: "Everything we build moves organizations beyond automation and toward autonomous execution.",
    },
    capabilities: {
      eyebrow: "Capabilities",
      title: "Systems designed as infrastructure.",
      sub: "Six disciplines. One unified intelligence architecture.",
      items: [
        { slug: "infra", title: "AI Infrastructure", desc: "End-to-end intelligence platforms — scalable, observable, sovereign." },
        { slug: "autonomous", title: "Autonomous Systems", desc: "Continuously executing systems that operate without human supervision." },
        { slug: "agents", title: "AI Agents", desc: "Specialist agents that reason, collaborate and execute at enterprise scale." },
        { slug: "automation", title: "Enterprise Automation", desc: "We re-engineer critical workflows into autonomous decision and action layers." },
        { slug: "architecture", title: "Intelligence Architecture", desc: "We design the intelligence architecture that governs the entire organization." },
        { slug: "predictive", title: "Predictive Intelligence", desc: "Predictive models anticipating markets, risk and opportunity in real time." },
      ],
    },
    technology: {
      eyebrow: "Technology",
      title: "One architecture. Five layers.",
      sub: "Every GAELON system is built on a vertically integrated proprietary stack.",
      nodes: [
        { slug: "neural", title: "Neural Systems", desc: "Foundation models and specialized neural networks." },
        { slug: "agents", title: "Autonomous Agents", desc: "Operational agents with multi-step reasoning." },
        { slug: "engines", title: "Decision Engines", desc: "Deterministic, auditable decision engines." },
        { slug: "execution", title: "Enterprise Execution", desc: "Native integration with corporate infrastructure." },
        { slug: "learning", title: "Continuous Learning", desc: "Continuous learning and optimization in production." },
      ],
    },
    showcase: {
      eyebrow: "Showcase",
      title: "Operating at industrial scale.",
      stats: [
        { slug: "cost", value: "82%", label: "Reduction in operational costs" },
        { slug: "workflows", value: "40,000+", label: "Automated workflows in production" },
        { slug: "efficiency", value: "340%", label: "Operational efficiency growth" },
      ],
      caption: "Aggregated indicators across enterprise deployments.",
    },
    philosophy: {
      eyebrow: "Philosophy",
      paragraphs: [
        "We believe intelligence is the next infrastructure layer of civilization.",
        "Organizations will no longer operate through manual execution.",
        "They will operate through autonomous intelligence.",
        "We are building that future.",
      ],
      signature: "— GAELON",
    },
    global: {
      eyebrow: "Global Presence",
      title: "Building intelligence systems for organizations worldwide.",
      regions: [
        { slug: "brazil", name: "Brazil" },
        { slug: "usa", name: "United States" },
        { slug: "europe", name: "Europe" },
        { slug: "middle-east", name: "Middle East" },
        { slug: "asia", name: "Asia" },
      ],
    },
    finalCta: {
      line1: "BUILD THE FUTURE",
      line2: "BEFORE IT ARRIVES.",
      sub: "A strategic conversation with GAELON. No cost. No friction.",
      cta: "Start with GAELON",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's architect your next era.",
      sub: "Tell us about your organization. We'll respond within 24 hours.",
      name: "Name",
      email: "Business email",
      company: "Company",
      message: "How can we help?",
      submit: "Talk on WhatsApp",
      submitting: "Opening…",
      success: "Redirecting to GAELON's WhatsApp.",
      error: "Could not send. Please try again in a moment.",
    },
    newsletter: {
      title: "Intelligence. Delivered to your inbox.",
      placeholder: "Your business email",
      submit: "Subscribe",
      submitting: "Subscribing…",
      success: "Subscription confirmed.",
      error: "Failed to subscribe. Try again.",
    },
    footer: {
      tagline: "Intelligence infrastructure for the next era.",
      nav: "Navigation",
      contact: "Contact",
      social: "Social",
      language: "Language",
      company: "Company",
      sac: "Support",
      rights: "All rights reserved.",
    },
  },

  es: {
    locale: "es",
    htmlLang: "es",
    nav: {
      capabilities: "Capacidades",
      technology: "Tecnología",
      showcase: "Resultados",
      philosophy: "Filosofía",
      contact: "Contacto",
      bookCall: "Agendar Consulta",
    },
    hero: {
      eyebrow: "Infraestructura de Inteligencia",
      headlineLine1: "INFRAESTRUCTURA",
      headlineLine2: "DE INTELIGENCIA",
      headlineLine3: "PARA LA PRÓXIMA ERA",
      sub: "Construimos sistemas autónomos de IA que redefinen la automatización, la toma de decisiones y el potencial humano.",
      ctaPrimary: "Agendar Consulta",
      ctaSecondary: "Explorar Sistemas",
      scrollHint: "Desliza para entrar",
    },
    mission: {
      eyebrow: "Misión",
      line1: "La tecnología debe",
      line2: "desaparecer dentro",
      line3: "de la inteligencia.",
      sub: "Todo lo que construimos lleva a las organizaciones más allá de la automatización, hacia la ejecución autónoma.",
    },
    capabilities: {
      eyebrow: "Capacidades",
      title: "Sistemas diseñados como infraestructura.",
      sub: "Seis disciplinas. Una arquitectura de inteligencia unificada.",
      items: [
        { slug: "infra", title: "AI Infrastructure", desc: "Plataformas de inteligencia integrales — escalables, observables, soberanas." },
        { slug: "autonomous", title: "Autonomous Systems", desc: "Sistemas que operan continuamente sin supervisión humana." },
        { slug: "agents", title: "AI Agents", desc: "Agentes especialistas que razonan, colaboran y ejecutan a escala empresarial." },
        { slug: "automation", title: "Enterprise Automation", desc: "Reingeniería de flujos críticos en capas autónomas de decisión y acción." },
        { slug: "architecture", title: "Intelligence Architecture", desc: "Diseñamos la arquitectura de inteligencia que gobierna toda la organización." },
        { slug: "predictive", title: "Predictive Intelligence", desc: "Modelos predictivos que anticipan mercados, riesgos y oportunidades en tiempo real." },
      ],
    },
    technology: {
      eyebrow: "Tecnología",
      title: "Una arquitectura. Cinco capas.",
      sub: "Cada sistema GAELON está construido sobre una pila propietaria verticalmente integrada.",
      nodes: [
        { slug: "neural", title: "Neural Systems", desc: "Modelos fundacionales y redes neuronales especializadas." },
        { slug: "agents", title: "Autonomous Agents", desc: "Agentes operacionales con razonamiento de múltiples pasos." },
        { slug: "engines", title: "Decision Engines", desc: "Motores de decisión deterministas y auditables." },
        { slug: "execution", title: "Enterprise Execution", desc: "Integración nativa con la infraestructura corporativa." },
        { slug: "learning", title: "Continuous Learning", desc: "Aprendizaje y optimización continuos en producción." },
      ],
    },
    showcase: {
      eyebrow: "Resultados",
      title: "Operando a escala industrial.",
      stats: [
        { slug: "cost", value: "82%", label: "Reducción de costos operativos" },
        { slug: "workflows", value: "40,000+", label: "Flujos automatizados en producción" },
        { slug: "efficiency", value: "340%", label: "Crecimiento de eficiencia operativa" },
      ],
      caption: "Indicadores agregados de implementaciones empresariales.",
    },
    philosophy: {
      eyebrow: "Filosofía",
      paragraphs: [
        "Creemos que la inteligencia es la próxima capa de infraestructura de la civilización.",
        "Las organizaciones ya no operarán mediante ejecución manual.",
        "Operarán mediante inteligencia autónoma.",
        "Estamos construyendo ese futuro.",
      ],
      signature: "— GAELON",
    },
    global: {
      eyebrow: "Presencia Global",
      title: "Construyendo sistemas de inteligencia para organizaciones en todo el mundo.",
      regions: [
        { slug: "brazil", name: "Brasil" },
        { slug: "usa", name: "Estados Unidos" },
        { slug: "europe", name: "Europa" },
        { slug: "middle-east", name: "Oriente Medio" },
        { slug: "asia", name: "Asia" },
      ],
    },
    finalCta: {
      line1: "CONSTRUYE EL FUTURO",
      line2: "ANTES DE QUE LLEGUE.",
      sub: "Una conversación estratégica con GAELON. Sin costo. Sin fricción.",
      cta: "Comenzar con GAELON",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Arquitectemos tu próxima era.",
      sub: "Cuéntanos sobre tu organización. Responderemos en 24 horas.",
      name: "Nombre",
      email: "Correo corporativo",
      company: "Empresa",
      message: "¿Cómo podemos ayudar?",
      submit: "Hablar por WhatsApp",
      submitting: "Abriendo…",
      success: "Redirigiendo al WhatsApp de GAELON.",
      error: "No se pudo enviar. Intenta nuevamente.",
    },
    newsletter: {
      title: "Inteligencia. Directo a tu bandeja.",
      placeholder: "Tu correo corporativo",
      submit: "Suscribirse",
      submitting: "Enviando…",
      success: "Suscripción confirmada.",
      error: "Error al suscribirse. Intenta de nuevo.",
    },
    footer: {
      tagline: "Infraestructura de inteligencia para la próxima era.",
      nav: "Navegación",
      contact: "Contacto",
      social: "Social",
      language: "Idioma",
      company: "Empresa",
      sac: "Soporte",
      rights: "Todos los derechos reservados.",
    },
  },

  zh: {
    locale: "zh",
    htmlLang: "zh-CN",
    nav: {
      capabilities: "能力",
      technology: "技术",
      showcase: "成果",
      philosophy: "理念",
      contact: "联系",
      bookCall: "预约战略会议",
    },
    hero: {
      eyebrow: "智能基础设施",
      headlineLine1: "智能",
      headlineLine2: "基础设施",
      headlineLine3: "通往下一个时代",
      sub: "我们构建自主人工智能系统,重新定义自动化、决策与人类潜能。",
      ctaPrimary: "预约战略会议",
      ctaSecondary: "探索系统",
      scrollHint: "向下滚动",
    },
    mission: {
      eyebrow: "使命",
      line1: "技术应当",
      line2: "消融于",
      line3: "智能之中。",
      sub: "我们所构建的一切,推动组织超越自动化,迈向自主执行。",
    },
    capabilities: {
      eyebrow: "能力",
      title: "以基础设施为蓝图的系统。",
      sub: "六大学科。一个统一的智能架构。",
      items: [
        { slug: "infra", title: "AI Infrastructure", desc: "端到端的智能平台 —— 可扩展、可观测、自主可控。" },
        { slug: "autonomous", title: "Autonomous Systems", desc: "无需人工监督即可持续运行的自主系统。" },
        { slug: "agents", title: "AI Agents", desc: "具备推理与协作能力的企业级智能体。" },
        { slug: "automation", title: "Enterprise Automation", desc: "将关键流程重构为自主决策与执行层。" },
        { slug: "architecture", title: "Intelligence Architecture", desc: "为整个组织设计统驭性的智能架构。" },
        { slug: "predictive", title: "Predictive Intelligence", desc: "实时预测市场、风险与机会的模型。" },
      ],
    },
    technology: {
      eyebrow: "技术",
      title: "一套架构。五个层级。",
      sub: "每一个 GAELON 系统,均构建于纵向集成的自研技术栈之上。",
      nodes: [
        { slug: "neural", title: "Neural Systems", desc: "基础模型与专用神经网络。" },
        { slug: "agents", title: "Autonomous Agents", desc: "具备多步推理能力的运营智能体。" },
        { slug: "engines", title: "Decision Engines", desc: "确定性、可审计的决策引擎。" },
        { slug: "execution", title: "Enterprise Execution", desc: "与企业基础设施的原生集成。" },
        { slug: "learning", title: "Continuous Learning", desc: "生产环境中的持续学习与优化。" },
      ],
    },
    showcase: {
      eyebrow: "成果",
      title: "以工业规模运行。",
      stats: [
        { slug: "cost", value: "82%", label: "运营成本下降" },
        { slug: "workflows", value: "40,000+", label: "已上线的自动化工作流" },
        { slug: "efficiency", value: "340%", label: "运营效率增长" },
      ],
      caption: "来自企业级部署的综合指标。",
    },
    philosophy: {
      eyebrow: "理念",
      paragraphs: [
        "我们相信,智能是人类文明的下一层基础设施。",
        "组织将不再依靠人工执行运转。",
        "它们将依靠自主智能运转。",
        "我们正在构建这个未来。",
      ],
      signature: "— GAELON",
    },
    global: {
      eyebrow: "全球布局",
      title: "为全球各地的组织构建智能系统。",
      regions: [
        { slug: "brazil", name: "巴西" },
        { slug: "usa", name: "美国" },
        { slug: "europe", name: "欧洲" },
        { slug: "middle-east", name: "中东" },
        { slug: "asia", name: "亚洲" },
      ],
    },
    finalCta: {
      line1: "在未来到来之前",
      line2: "亲手构建它。",
      sub: "与 GAELON 的一次战略对话。无成本,无阻力。",
      cta: "从 GAELON 开始",
    },
    contact: {
      eyebrow: "联系",
      title: "让我们一起架构你的下一个时代。",
      sub: "请告诉我们你的组织。我们将在 24 小时内回复。",
      name: "姓名",
      email: "企业邮箱",
      company: "公司",
      message: "我们如何提供帮助?",
      submit: "通过 WhatsApp 联系",
      submitting: "正在打开…",
      success: "正在跳转到 GAELON 的 WhatsApp。",
      error: "发送失败,请稍后再试。",
    },
    newsletter: {
      title: "智能资讯,直达邮箱。",
      placeholder: "您的企业邮箱",
      submit: "订阅",
      submitting: "提交中…",
      success: "订阅成功。",
      error: "订阅失败,请重试。",
    },
    footer: {
      tagline: "通往下一个时代的智能基础设施。",
      nav: "导航",
      contact: "联系",
      social: "社交",
      language: "语言",
      company: "公司",
      sac: "客服",
      rights: "保留所有权利。",
    },
  },
};

export const SUPPORTED_LOCALES = [
  { code: "pt-br", label: "PT", full: "Português (BR)" },
  { code: "en", label: "EN", full: "English" },
  { code: "es", label: "ES", full: "Español" },
  { code: "zh", label: "ZH", full: "中文" },
];

export default translations;
